import React from 'react';
import './PlaceholderPage.css';

function PlaceholderPage({ title, description }) {
  return (
    <div className="teacher-placeholder">
      <h1 className="teacher-placeholder__title">{title}</h1>
      <p className="teacher-placeholder__desc">{description || 'This page will be built in an upcoming sprint.'}</p>
    </div>
  );
}

export default PlaceholderPage;
